import type { Middleware, PayloadAction } from "@reduxjs/toolkit";
import { clearCacheAction } from "Data/Actions/System";
import { logoutUserAction } from "Data/Redux/Slices/User";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const logoutOnUnauthorized: Middleware =
	(store) => (next) => (action) => {
		const assertedAction = action as PayloadAction<number>;

		if (assertedAction.type?.includes("rejected") && assertedAction.payload === 401) {
			store.dispatch(logoutUserAction());
			store.dispatch(clearCacheAction());
		}

		return next(action);
	};
